module.exports = __webpack_public_path__ + "be3855dface18ee1aa58811007a665d3.png";